/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';

import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile_en from './esStory.md';
import markdownFile_fr_CA from './esStory.fr_CA.md';

const md = i18nData({
  en: new MarkdownScript(markdownFile_en),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});

function video ({ level, regionData, i18n }) {
  const md_i18n = i18n(md);
  return (
    videoSlide({
      id: `video-${level}`,
      notes: md_i18n.getSubSectionAsHtml(`Es Story ${level}`, 'Notes', false, regionData),
      youTubeId: md_i18n.getSectionMetadata(`Es Story ${level}`, 'YouTube', regionData)
    })
  );
}

function esStorySection ({ level, subStory, regionData, i18n }) {
  const validLevels = ['1a','1b','1c','2a','3a','3b','4a','4b'];
  const theLevel = `${level}${subStory || ''}`;

  if (validLevels.indexOf(theLevel) < 0) {
    return headingSlide({ heading: 'Unknown' });
  }

  return (
    <Section id={`es-story-${theLevel}`}>
      {/* Video */}
      {video({level: theLevel, regionData, i18n})}
    </Section>
  );
}

export default esStorySection;



// WEBPACK FOOTER //
// ./programs/h2whoa/sections/12_esStory/esStorySection.jsx